import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';
import { SvgIconProps } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import React from 'react';
import { BenefitMetadataExtensionInterface } from '../../../../extension/interface/benefit-metadata.extension.interface';

export class BikeBenefitMetadataExtension extends BenefitMetadataExtensionInterface {
  benefitId: BenefitDTOBenefitEnum = BenefitDTOBenefitEnum.Bike;
  get Icon(): React.ComponentType<SvgIconProps> {
    return DirectionsBikeIcon;
  }
}
